import { useState, useCallback } from 'react';

interface ApiResponse<T> {
  data: T | null;
  error: string | null;
  loading: boolean;
}

interface QueryParams {
  [key: string]: string | number | boolean;
}

export function useApi<T>() {
  const [response, setResponse] = useState<ApiResponse<T>>({
    data: null,
    error: null,
    loading: false,
  });

  const makeGetRequest = useCallback(async (url: string, queryParams?: QueryParams) => {
    setResponse(prev => ({ ...prev, loading: true, error: null }));
    
    try {
      const queryString = queryParams
        ? '?' + new URLSearchParams(
          Object.entries(queryParams).map(([key, value]) => [key, String(value)])
        ).toString()
        : '';
        
        const fullUrl = `${url}${queryString}`;
        
      
      const res = await fetch(fullUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || 'Something went wrong');
      }

      setResponse({
        data,
        error: null,
        loading: false,
      });

      return data;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred';
      setResponse({
        data: null,
        error: errorMessage,
        loading: false,
      });
      throw error;
    }
  }, []);

  return {
    ...response,
    makeGetRequest,
  };
} 